export default __webpack_public_path__ + "static/media/LCA.4bdae546.svg";